import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { HttpHelperService } from '../service/helper/http/http-helper.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
})
export class ForgetPasswordComponent implements OnInit {
  public isLoginFormVisible = true;
  public forgotPasswordSubmitted = false;
  token:any;
  forgetPasswordForm: FormGroup;
  constructor(private formBuilder: FormBuilder, private router: Router,private httpClientService: HttpHelperService,
    private authService:AuthenticationService, private activatedRoute: ActivatedRoute) {
      this.forgotPasswordSubmitted=false;  
      this.activatedRoute.queryParams.subscribe(params => {
         this.token=  Object.keys(params);
      // console.log(this.token[0])
      });
    }

  ngOnInit() {
    this.forgotPasswordSubmitted = false;
    this.forgetPasswordForm = this.formBuilder.group({
      Newpassword: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{6,}')]],
    //  Oldpassword: ['', Validators.required],
      Confirmpassword: ['', Validators.required],
    });
   
  }
  ResetpassSubmit() {
    this.forgotPasswordSubmitted = true;
 if (this.forgetPasswordForm.invalid) {
      return;
    } 
     const param = {
       "confirmPassword":this.forgetPasswordForm.value.Confirmpassword,
        "deviceId": "",
        "fcmToken": "",
        "password": this.forgetPasswordForm.value.Newpassword,
        "token": this.token[0]
      }
    this.httpClientService.postRequest('api/auth/password/reset',param).subscribe((response: any) => {
     if(response.success==true){
      this.forgotPasswordSubmitted=false;
      window.alert("Password has been changed successfully.");
      this.router.navigate(['/login']);
     }
      
    })
  }

}
